export default {
  notification: ({ notification }) => notification,
};
